class FilterDrawer extends HTMLElement {
  constructor() {
    super();
    this.openBtn = null;
    this.closeBtn = null;
    this.overlay = null;
  }

  connectedCallback() {
    this.openBtn = document.getElementById("filter-open-btn");
    this.closeBtn = this.querySelector(".filter-drawer__close");
    this.overlay = this.querySelector(".filter-drawer__overlay");

    this.openDrawer = this.openDrawer.bind(this);
    this.closeDrawer = this.closeDrawer.bind(this);

    if (this.openBtn) {
      this.openBtn.addEventListener("click", this.openDrawer);
    }

    if (this.closeBtn) {
      this.closeBtn.addEventListener("click", this.closeDrawer);
    }

    if (this.overlay) {
      this.overlay.addEventListener("click", this.closeDrawer);
    }

    if (sessionStorage.getItem("filterDrawerOpen") === "true") {
      this.classList.add("filter-drawer--open");
    }
  }

  disconnectedCallback() {
    if (this.openBtn) {
      this.openBtn.removeEventListener("click", this.openDrawer);
    }
    if (this.closeBtn) {
      this.closeBtn.removeEventListener("click", this.closeDrawer);
    }
    if (this.overlay) {
      this.overlay.removeEventListener("click", this.closeDrawer);
    }
  }

  openDrawer() {
    this.classList.add("filter-drawer--open");
    sessionStorage.setItem("filterDrawerOpen", "true");
  }

  closeDrawer() {
    this.classList.remove("filter-drawer--open");
    sessionStorage.setItem("filterDrawerOpen", "false");
  }
}

customElements.define("filter-drawer", FilterDrawer);

function ensureLoadingOverlay() {
  const productGrid = document.querySelector(".collection-products");
  if (!productGrid) return;

  if (!productGrid.querySelector(".collection-products__loading")) {
    const loadingOverlay = document.createElement("div");
    loadingOverlay.className = "collection-products__loading";
    loadingOverlay.innerHTML = `<div class="spinner"></div>`;
    productGrid.appendChild(loadingOverlay);
  }
}

function showLoading() {
  const productGrid = document.querySelector(".collection-products");
  if (!productGrid) return;

  ensureLoadingOverlay();
  productGrid.classList.add("is-loading");
}

function hideLoading() {
  const productGrid = document.querySelector(".collection-products");
  if (!productGrid) return;

  productGrid.classList.remove("is-loading");
}

document.addEventListener("change", function (e) {
  const target = e.target;

  if (
    target.closest(".collection-filter") &&
    (target.type === "checkbox" || target.type === "range")
  ) {
    showLoading();

    const openAccordions = Array.from(
      document.querySelectorAll(".collection-filter .accordion.accordion--open")
    ).map(acc =>
      acc.closest(".collection-filter")?.dataset.filterKey
    );
  }
});


const observer = new MutationObserver(() => {
  hideLoading();
  ensureLoadingOverlay();
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

document.addEventListener("click", function (e) {
  const clearBtn = e.target.closest(".collection-filters__clear-all");
  if (!clearBtn) return;

  e.preventDefault();

  const sectionId = document
    .querySelector("collection-filters")
    ?.dataset.sectionId;

  if (!sectionId) return;

  showLoading();

  const openAccordions = Array.from(
    document.querySelectorAll(".collection-filter .accordion.accordion--open")
  ).map(acc =>
    acc.closest(".collection-filter")?.dataset.filterKey
  );

  const url = new URL(clearBtn.dataset.clearUrl, window.location.origin);
  url.searchParams.set("section_id", sectionId);

  fetch(url.toString())
    .then((response) => response.text())
    .then((html) => {
      const parser = new DOMParser();
      const doc = parser.parseFromString(html, "text/html");

      const newFilters = doc.querySelector("collection-filters");
      const newProducts = doc.querySelector(".collection-products");

      if (newFilters) {
        document.querySelector("collection-filters").replaceWith(newFilters);

        if (openAccordions?.length) {
          openAccordions.forEach((key) => {
            const newAccordion = document.querySelector(
              `.collection-filter[data-filter-key="${key}"] .accordion`
            );

            if (newAccordion) {
              newAccordion.classList.add("accordion--open");

              const content = newAccordion.querySelector(".accordion__content");
              if (content) {
                newAccordion.style.setProperty(
                  "--accordion-content-height",
                  content.scrollHeight + "px"
                );
              }
            }
          });
        }
      }

      if (newProducts) {
        document
          .querySelector(".collection-products")
          .replaceWith(newProducts);
      }

      window.history.replaceState({}, "", clearBtn.dataset.clearUrl);
      hideLoading();
    })
    .catch(() => {
      hideLoading();
    });
});

function handleize(str) {
  return str
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
}

document.addEventListener(
  "click",
  function (e) {
    const clearBtn = e.target.closest(".collection-filter__clear");
    if (!clearBtn) return;

    // 🚫 Prevent accordion from toggling
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const paramName = clearBtn.dataset.paramName;
    const filtersEl = document.querySelector("collection-filters");
    const sectionId = filtersEl?.dataset.sectionId;

    if (!sectionId || !paramName) return;

    showLoading();

    const openAccordions = Array.from(
      document.querySelectorAll(".collection-filter .accordion.accordion--open")
    ).map(acc =>
      acc.closest(".collection-filter")?.dataset.filterKey
    );

    const url = new URL(window.location.href);

    Array.from(url.searchParams.keys()).forEach((key) => {
      if (key.startsWith(paramName)) {
        url.searchParams.delete(key);
      }
    });

    url.searchParams.set("section_id", sectionId);

    fetch(url.toString())
      .then((response) => response.text())
      .then((html) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, "text/html");

        const newFilters = doc.querySelector("collection-filters");
        const newProducts = doc.querySelector(".collection-products");

        if (newFilters) {
          document.querySelector("collection-filters").replaceWith(newFilters);

          // ✅ Restore accordion open state properly
          if (openAccordions?.length) {
            openAccordions.forEach((key) => {
              const newAccordion = document.querySelector(
                `.collection-filter[data-filter-key="${key}"] .accordion`
              );

              if (newAccordion) {
                newAccordion.classList.add("accordion--open");

                const content =
                  newAccordion.querySelector(".accordion__content");

                if (content) {
                  newAccordion.style.setProperty(
                    "--accordion-content-height",
                    content.scrollHeight + "px"
                  );
                }
              }
            });
          }
        }

        if (newProducts) {document.querySelector(".collection-products").replaceWith(newProducts);}

        window.history.replaceState({}, "", url.pathname + url.search);
        hideLoading();
      })
      .catch(() => hideLoading());
  },
  true
);